// extracted by mini-css-extract-plugin
export default {"heading":"About_heading__Mb4fm","heading2":"About_heading2__P3f6G","para":"About_para__C6-6-"};